import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import {Observable} from 'rxjs/Observable';

let headers = new HttpHeaders({
  'Content-Type': 'multipart/form-data;',
  'Accept': 'application/json' });
let options = { headers: headers };

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  // SERVER_URL: string = "https://bricksandbeams.000webhostapp.com";
  // SERVER_URL: string = "http://www.bricksanbeams.in";
  SERVER_URL: string = "";

  constructor(private http: HttpClient) { }

  getProjects() {
    return this.http.get(this.SERVER_URL+'/php/get_projects.php');
  }

  getProject(id) {
    return this.http.get(this.SERVER_URL+`/php/get_projects.php?id=${id}`);
  }

  getImages(id: any) {
    return this.http.get(this.SERVER_URL+`/php/view.php?id=${id}`);
  }

  sendMail(name, email, number, message) {
    var formData: any = new FormData();
    formData.append("type", "mail");
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", number);
    formData.append("message", message);

    return this.http.post(this.SERVER_URL+`/php/mail.php`, formData);
  }

  subscribeMail(email) {
    const formData: any = new FormData();
    formData.append("type", "subscribe");
    formData.append("email", email);

    return this.http.post(this.SERVER_URL+`/php/mail.php`, formData);
  }
}
